import { gql } from 'urql';

const baseRequestBookingFragment = gql`
	fragment BaseRequestBookingFragment on Request {
		id
		artist {
			id
			name
			url
			vat_invoicing
			rider_link
		}
		organization {
			logo
		}
		confirmed
		confirmed_name
		confirmed_phone
		confirmed_email
		confirmed_at
		steps_done

		main_email

		event_name
		event_date
		event_address_place
		event_address_street
		event_address_city
		event_address_zip
		event_address_gps

		promoter_name
		promoter_email
		promoter_phone

		contract_ico
		contract_address_street
		contract_address_city
		contract_address_zip
		contract_name

		tech_sound_name
		tech_sound_email
		tech_sound_phone
		tech_update_at

		tech_contact_name
		tech_contact_email
		tech_contact_phone

		time_arrival
		time_podium_access
		time_sound_test
		time_dinner
		time_hall_opening
		time_performance
		time_update_at

		fee_type
		fee_amount
		fee_travel
		fee_total
		fee_other
		fee_payment_type
		fee_paying_name
		fee_paying_email
		fee_vat

		accomodation
		accomodation_type
		accomodation_name
		accomodation_street
		accomodation_city
		accomodation_zip
		accomodation_gps
		accomodation_event_distance
		accomodation_web
		accomodation_phone
		accomodation_check_in
		accomodation_check_out
		accomodation_breakfast
		accomodation_internet_access
		accomodation_update_at

		prefilled

		notified_at

		isCompleted
	}
`;

// it is used to create a new request by booker URL
export const QUERY_BOOKER = gql`
	query Booker($url: String) {
		booker(url: $url) {
			url
			logo
		}
	}
`;

// gets information about booker - used for to get logo
export const QUERY_BOOKER_INFO = gql`
	query BookerByRequestUrl($url: String) {
		bookerByRequestUrl(url: $url) {
			url
			logo
		}
	}
`;

export const QUERY_REQUEST = gql`
	query BookingRequest($url: String) {
		request(url: $url) {
			...BaseRequestBookingFragment
		}
	}

	${baseRequestBookingFragment}
`;

export const QUERY_REQUEST_STATE = gql`
	query RequestState($url: String) {
		requestState(url: $url) {
			id
			finished
		}
	}
`;

export const QUERY_REQUEST_DATA = gql`
	query Request($url: String) {
		request(url: $url) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_START = gql`
	mutation UpdateRequestDataStart($url: String) {
		updateRequestDataStart(url: $url) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const QUERY_REQUEST_DATA_EVENT = gql`
	query Request($url: String) {
		request(url: $url) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_EVENT = gql`
	mutation UpdateRequestDataEvent($url: String, $input: DataEventInput) {
		updateRequestDataEvent(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_PROMOTER = gql`
	mutation UpdateRequestDataPromoter($url: String, $input: DataPromoterInput) {
		updateRequestDataPromoter(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_TECH = gql`
	mutation UpdateRequestDataTech($url: String, $input: DataTechInput) {
		updateRequestDataTech(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_TIMES = gql`
	mutation UpdateRequestDataTimes($url: String, $input: DataTimesInput) {
		updateRequestDataTimes(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_FEE = gql`
	mutation UpdateRequestDataFee($url: String, $input: DataFeeInput) {
		updateRequestDataFee(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_UPDATE_DATA_ACCOMODATION = gql`
	mutation UpdateRequestDataAccomodation($url: String, $input: DataAccomodationInput) {
		updateRequestDataAccomodation(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const MUTATION_CONFIRM_REQUEST = gql`
	mutation ConfirmRequest($url: String, $input: ConfirmationInput) {
		confirmRequest(url: $url, input: $input) {
			...BaseRequestBookingFragment
		}

		${baseRequestBookingFragment}
	}
`;

export const QUERY_ARTISTS = gql`
	query Artists($url: String) {
		artists(url: $url) {
			id
			name
			url
			vat_invoicing
			rider_link
		}
	}
`;
